import { Link } from "react-router-dom";
import type { CatalogItem } from "@/utils/catalog";
import { formatMeta } from "@/utils/catalog";

interface MovieCardProps {
  item: CatalogItem;
  showSummary?: boolean;
}

export default function MovieCard({ item, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} ${item.genres.join(" ")} 影视推荐`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-background-950/75 px-2 py-1 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-accent-400"></i>
          {item.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-accent-500 px-2 py-1 text-[11px] font-medium text-background-50">
          {item.category === "movie" ? "电影" : "剧集"}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.genres.slice(0, 2).join(" · ")}</span>
          <span className="text-foreground-300">|</span>
          <span>{item.year}</span>
          <span className="text-foreground-300">|</span>
          <span>{formatMeta(item)}</span>
        </div>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {item.summary}
          </p>
        )}
      </div>
    </Link>
  );
}